/**
 * Authenticated buyer marketplace API (Treydora.com → TreydoraEdBackend).
 */
import { getApiBaseUrl } from "../utils/getApiBaseUrl";
import { authHeaders, getAuthToken } from "./authApi";

const API_BASE_URL = getApiBaseUrl();

async function parseJson(res) {
  try {
    return await res.json();
  } catch {
    return {};
  }
}

export function marketplaceBuyerRequiresLogin() {
  return !getAuthToken();
}

/** @returns {Promise<object[]>} */
export async function fetchMyMarketplacePurchases() {
  const res = await fetch(`${API_BASE_URL}/api/marketplace/my-purchases`, {
    headers: { ...authHeaders() },
  });
  const body = await parseJson(res);
  if (res.status === 401 || res.status === 403) {
    const err = new Error(body.message || "Please log in.");
    err.code = "AUTH";
    throw err;
  }
  if (!res.ok) {
    throw new Error(body.message || "Could not load purchases.");
  }
  return body.data?.entitlements ?? [];
}
